import { BlockAnalyzed } from "./block-analyzed";
/**
 * Componente per visualizzare una data analizzata
 * Estende BlockAnalyzed per specificare il template della data
 */
export class BlockAnalyzedDate extends BlockAnalyzed {
    static override webComponentName: string = "block-analyzed-date";
    protected override _templateId: string = "block-analyzed-date";
    protected isValidValue(value: any): boolean {
        // la data è in forma di stringa YYYY-MM-DD o oggetto Date
        if (value instanceof Date) {
            return !isNaN(value.getTime());
        }
        if (typeof value === 'string') {
            // semplice regex per verificare il formato YYYY-MM-DD
            const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
            return dateRegex.test(value);
        }
        return false;
    }

}